import ContraCP from './../contraCP/ContraCP';
import previewHtml from './preview.html';

class previewController {
    constructor($scope, $timeout, $sce) {
        'ngInject';

        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$sce = $sce;
        this.CP = null;
        this.downloadLink = null;
        this.uniqueId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
        this.CPdimensionsTimeout = null;
        this.CPdimensions = {
            x: 765,
            y: 510
        };
        this.mainShape = null;
    }

    $postLink() {
        // Bindings ready
        if (this.$scope.elementWidth) {
            console.log('this.$scope.elementWidth', this.$scope.elementWidth);
            this.CPdimensions = {
                x: this.$scope.elementWidth,
                y: this.$scope.elementWidth / 1.5
            };
        }

        this.$timeout(() => {
            // View render end
            if (this.$scope.elementWidth) {
                console.log('this.$scope.elementWidth', this.$scope.elementWidth);
                this.CPdimensions = {
                    x: this.$scope.elementWidth,
                    y: this.$scope.elementWidth / 1.5
                };
            }

            this.$scope.$watch(
                () => this.$scope.elementWidth,
                (newVal, oldVal) => {
                    if (!newVal) return;
                    if (newVal === this.CPdimensions.x) return;

                    console.log('previewController::$watch elementWidth', newVal);
                    this.CPdimensions = {
                        x: newVal,
                        y: newVal / 1.5
                    };
                }
            );

            this.$scope.$watch(() => this.CPdimensions, (newVal, oldVal) => {
                const autoSize = typeof this.autoSize === 'undefined' ? false : JSON.parse(this.autoSize);
                if (!autoSize || !this.CP) return;


                if (!newVal) return;
                if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;

                if (this.CPdimensionsTimeout) {
                    this.$timeout.cancel(this.CPdimensionsTimeout);
                    this.CPdimensionsTimeout = null;
                }

                this.CPdimensionsTimeout = this.$timeout(
                    () => {
                        console.log('previewController::$watch CPdimensions', newVal.x, newVal.y);
                        this.CP.setView(this.CPdimensions.x, this.CPdimensions.y);
                    },
                    100
                );

            }, true);

            this.$scope.$watch(() => {
                return {
                    model: this.model,
                    previewType: parseInt(this.type) || 1,
                    width: typeof this.width === 'undefined' ? 300 : parseInt(this.width),
                    height: typeof this.height === 'undefined' ? 300 : parseInt(this.height),
                    padding: typeof this.padding === 'undefined' ? 30 : parseInt(this.padding),
                    dimensioning: typeof this.dimensioning === 'undefined' ? true : JSON.parse(this.dimensioning),
                    autoSize: typeof this.autoSize === 'undefined' ? false : JSON.parse(this.autoSize),
                }
            }, (newVal, oldVal) => {
                if (!newVal || !newVal.model) return false;

                console.log('previewController::$watch', newVal);

                if (oldVal.model) document.getElementById(`preview-board-${this.uniqueId}`).innerHTML = '';

                if (newVal.autoSize) {
                    newVal.width = this.CPdimensions.x;
                    newVal.height = this.CPdimensions.y;
                    console.log('previewController::autoSize', newVal.width, newVal.height);
                }

                console.log('preview padding', newVal.padding);
                this.CP = new ContraCP(`#preview-board-${this.uniqueId}`, newVal.width, newVal.height, newVal.previewType, newVal.padding);

                this.$timeout(() => {
                    this.redraw(newVal);
                }, 200);
                
            }, true);
        });
    }

    redraw({model, previewType, dimensioning}) {
        console.log('previewController::redraw', model, previewType, dimensioning);

        const {polygon, type, ...mainShapeParams} = model.mainShape;
        const mainShape = this.CP.ElementFactory(type, mainShapeParams);

        this.mainShape = mainShape;

        if (dimensioning) {
            mainShape.dimensioning();
        }
        console.log('previewController::redraw -> setMainShape', type, mainShapeParams, mainShape);
        this.CP.setMainShape(mainShape);

        if (model.elements && model.elements.length > 0) {
            for (const elementModel of model.elements) {
                const {type, shape, rawElement, name, image, removed, ...elementParams} = elementModel;

                const element = this.CP.ElementFactory(type, this.CP.ElementFactory(shape, elementParams));
                console.log('previewController::redraw -> element', type, shape, elementParams);
            }
        }

        if (previewType === 1) {

            if (this.downloadLink) {
                URL.revokeObjectURL(this.downloadLink);
            }

            mainShape.mergePaths(true);
            const url = this.CP.getBlobUrl();
            console.log('previewController::redraw -> downloadLink', url);

            this.downloadLink = this.$sce.trustAsResourceUrl(url);
        }

        if (previewType === 2) {
            mainShape.showSubstractedMainShape();
        }

        if (this.serializedOutput && typeof this.serializedOutput === 'function') {
            const serialized = this.CP.getSvgSerialized();
            console.log('previewController::redraw -> serializedOutput', serialized);
            this.serializedOutput({svg: serialized});
        }
    }

    $onDestroy() {
        if (!this.CP) return;

        console.log('previewController::$onDestroy -> ' + this.uniqueId);
    }
}

let previewComponent = {
    bindings: {
        'model': '<',
        'type': '<',
        'width': '<',
        'height': '<',
        'padding': '<',
        'dimensioning': '<',
        'serializedOutput': '&',
        'autoSize': '<',
        'hideText': '<'
    },
    template: previewHtml,
    controller: previewController
};

export default previewComponent;
